import { createSlice } from '@reduxjs/toolkit'

const initialAccountState = {
  userIdListArray: [],
  accountNameValue: '',
  accountStatusValue: 0,
  accountPhoneValue: '',
  userPhoneNumber: '',
  userLoginValue: '',
  userEmail: '',
  userFirstName: '',
  userLastName: '',
  userGroupId: 0,
  userMFAValue: '',
  userIdValue: 0,
  siteDescriptionValue: '',
  siteNameString: '',
  accountModules: [],
  activeModuleId: null,
  activeModuleName: '',
  entityName: '',
  actionName: '',
  usersName: '',
  startDt: null,
  endDt: null,
}

const accountSlice = createSlice({
  name: 'account',
  initialState: initialAccountState,
  reducers: {
    userIdListHandler(state, action) {
      state.userIdListArray = action.payload
    },
    accountNameHandler(state, action) {
      state.accountNameValue = action.payload
    },
    accountStatusHandler(state, action) {
      state.accountStatusValue = action.payload
    },
    accountPhoneNumberHandler(state, action) {
      state.accountPhoneValue = action.payload
    },
    userPhoneNumberHandler(state, action) {
      state.userPhoneNumber = action.payload
    },
    userLoginValueHandler(state, action) {
      state.userLoginValue = action.payload
    },
    userGroupIdHandler(state, action) {
      state.userGroupId = action.payload
    },
    userFirstNameHandler(state, action) {
      state.userFirstName = action.payload
    },
    userLastNameHandler(state, action) {
      state.userLastName = action.payload
    },
    userEmailHandler(state, action) {
      state.userEmail = action.payload
    },
    userMFAValueHandler(state, action) {
      state.userMFAValue = action.payload
    },
    userIdValueHandler(state, action) {
      state.userIdValue = action.payload
    },
    accountModuleHandler(state, action) {
      state.accountModules = action.payload
    },
    setActiveModule(state, action) {
      state.activeModuleId = action.payload?.id
      state.activeModuleName = action.payload?.name
    },
    auditlogEntityHandler(state, action) {
      state.entityName = action.payload
    },
    auditlogActionHandler(state, action) {
      state.actionName = action.payload
    },
    auditlogUsersHandler(state, action) {
      state.usersName = action.payload
    },
    startDateHandler(state, action) {
      state.startDt = action.payload
    },
    endDateHandler(state, action) {
      state.endDt = action.payload
    },
  },
})

export const accountActions = accountSlice.actions
export default accountSlice.reducer
